<script lang="ts">
	export let title = '';
	export let noborder = false;
	export let inline = false;
	export let disabled = false;
	let clazz: string;
	export { clazz as class };
	export let flex: boolean;
</script>

<div class={`root ${clazz || ''}`} class:noborder class:inline class:flex>
	{#if disabled}
		<div class="disabled-overlay">
			<div class="mdc-typography--headline3">Disabled</div>
		</div>
	{/if}
	{#if title}
		<span class="title mdc-typography--body2">{title}</span>
	{/if}
	<slot />
</div>

<style>
	.root {
		border: 1px solid #bfbfbf;
		position: relative;
		margin-bottom: 16px;
		border-radius: 4px;
		padding: 12px 20px;
		transition: border 0.25s ease-in;
	}

	.root:hover {
		border-color: #9b9b9b;
	}

	.noborder {
		border-color: transparent;
	}

	.noborder:hover {
		border-color: transparent;
	}

	.root:hover .title {
		/* color: var(--text-color); */
		color: var(--mdc-theme-primary);
		/* text-shadow: 1px 2px 3px #30303030; */
	}

	.title {
		position: absolute;
		color: #9b9b9b;
		top: 0;
		left: 30px;
		transform: translateY(-50%);
		background-color: var(--background-color);
		padding: 0 10px;
		transition: color 0.25s ease-in;
		font-weight: 500;
	}

	.inline {
		flex: 1;
		margin-right: 1rem;
	}

	.disabled-overlay {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(255, 255, 255, 0.25);
		backdrop-filter: blur(1px);
		z-index: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		color: var(--mdc-theme-secondary);
	}

	.flex {
		display: flex;
	}
</style>
